<template>
  <div v-if="livingOption && subsection" class="subsection">    
    <main-content
      :background-image="subsection.backgroundImage"
      right-sidebar="true"
    >
      <div v-if="subsectionChildType === 'property'">
        <router-link
          v-for="child in children"
          class="touch"
          :key="child._id"
          tag="div"
          :to="getRouterLink(child)"
        >
          <availability-marker 
            :filtered="child.filter"
            :x="child.marker.x"
            :y="child.marker.y"
            :status="child.status"
          ></availability-marker>
        </router-link>
      </div>
      <transition name="fade">
        <img v-if="showAllProperties" class="main-content__background" :key="subsection.allPropertiesFloorplate" :src="`${$store.state.assetsPath}${subsection.allPropertiesFloorplate}`">
      </transition>
      <transition name="fade">
        <div v-if="showAllProperties">
          <router-link
            v-for="property in allProperties"
            class="touch"
            :key="property._id"
            tag="div"
            :to="property.routerLink"
          >
            <availability-marker 
              :filtered="property.filter"
              :x="property.livingOptionMarker.x"
              :y="property.livingOptionMarker.y"
              :status="property.status"
            ></availability-marker>
          </router-link>
        </div>      
      </transition>
      <transition name="fade">
        <action-bar v-if="!showAllProperties">{{ actionText }}</action-bar>
      </transition>      
    </main-content>
    <right-sidebar
      :logo="$store.state.config.sidebarLogo"
      :minimap="livingOption.sidebarMinimap"
      :heading="sidebarHeading"
      :description="sidebarDescription"
      :navigation-items="navigationItems"
      :enable-slide-out="true"
    >
      <!-- <div slot="top-slot">
        <property-filter/>
      </div> -->
      <template slot="bottom-slot">
        <button
          v-if="subsection.allPropertiesFloorplate && subsection.allProperties.length"
          class="btn btn--blue touch"
          @click="toggleShowAllProperties()"
        >{{ showAllProperties ? 'Hide All Properties' : 'View All Properties' }}</button>
        <router-link tag="button" class="right-sidebar__back" :to="backRoute"><fa icon="chevron-left"/>{{ language.code === 'en' ? 'Back' : 'عودة' }}</router-link>
      </template>
      <template slot="slide-out-slot">
        <property-filter/>
      </template>
    </right-sidebar>
  </div>  
</template>
<script>
// A subsection either links to properties or other subsections
import ActionBar from '@/components/ActionBar'
import AvailabilityMarker from '@/components/AvailabilityMarker'
import MainContent from '@/components/MainContent'
import PropertyFilter from '@/components/PropertyFilter'
import RightSidebar from '@/components/RightSidebar'
import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  name: 'subsection',
  components: { ActionBar, AvailabilityMarker, MainContent, PropertyFilter, RightSidebar },

  data () {
    return {
      showAllProperties: false
    }
  },

  computed: {
    ...mapGetters({
      language: 'language',
      livingOption: 'property/activeLivingOption',
      subsection: 'property/activeSubsection',
      subSubsections: 'property/subSubsectionsWithFiltering',
      subsections: 'property/subsections',
      propertiesFiltered: 'property/propertiesFiltered',
    }),

    allProperties () {
      let properties = []
      this.subsection.allProperties.forEach(property => {
        const routerLink = this.generateRouterLink(property._id)
        if (routerLink && property.livingOptionMarker.x !== 100) {
          property.routerLink = routerLink
          property.filter = false
          property.models.forEach(model => {
            const beds = parseInt(model.beds) > 4 ? 4 : parseInt(model.beds)
            if (this.$store.state.property.inputType && this.$store.state.property.inputType !== model.type) {
              property.filter =  true
            } else if ((this.$store.state.property.inputBeds || this.$store.state.property.inputBeds === 0) && this.$store.state.property.inputBeds !== beds) {
              property.filter =  true
            }
          })

          properties.push(property)
        }
      })
      return properties
    },    

    actionText () {  
      let propertyType = this.subsectionChildType === 'property' && this.livingOption.propertyTypes.length ? this.livingOption.propertyTypes[0] : this.subsection.subsectionType
      if (!propertyType && this.subsection.properties.length) {
        propertyType = this.subsection.properties[0].models[0].type
      } else {
        return ''
      }
      const grammerArticle = ['a', 'e', 'i', 'o', 'u'].includes(propertyType.charAt(0)) ? 'an' : 'a' // a/an
      return `select ${grammerArticle} ${propertyType}` // select an/a apartment/townhouse
    },

    backRoute () {
      if (this.$store.state.route.query.parentSubsectionId) {
        return`/live/${this.livingOption._id}/subsection/${this.$store.state.route.query.parentSubsectionId}`
      } else {
        return`/live/${this.livingOption._id}`
      }
    },

    children () {
      if (this.subsectionChildType === 'property') {
        return this.propertiesFiltered
      } else {
        return this.subSubsections
        // return this.subsection.subsections
      }
    },

    navigationItems () {
      // if subsection has subsection children then create nav items from those children instead of living options subsections
      if (this.$store.state.route.query.parentSubsectionId && this.subsection && !this.subsection.subsections) {
        console.log('navigationItems 1')
        
        // subsection inception end
        const subsection = _.find(this.subsections, subsection => {
          return subsection._id === this.$store.state.route.query.parentSubsectionId
        })

        return subsection.subsections.map(subsection => {
          return {
            label: subsection.displayName,
            to: `/live/${this.livingOption._id}/subsection/${subsection._id}?parentSubsectionId=${this.$store.state.route.query.parentSubsectionId}`,
            disabled: subsection.filter
          }
        })
      } else if (this.$store.state.route.query.parentSubsectionId && this.subsection && this.subsection.subsections) { 
        console.log('navigationItems 2')
        // subsection inception
        return this.subSubsections.map(subsection => {
          return {
            label: subsection.displayName,
            to: `/live/${this.livingOption._id}/subsection/${subsection._id}?parentSubsectionId=${this.subsection._id}`,
            disabled: subsection.filter
          }
        })
      } else if (this.subsection.subsections && this.subsection.subsections.length) {
        console.log('navigationItems 3')
        // const filteredSubsections = this.subsection.subsections
        const filteredSubsections = this.subSubsections
        return filteredSubsections.map(subsection => {
          return {
            label: subsection.displayName,
            to: `/live/${this.livingOption._id}/subsection/${subsection._id}?parentSubsectionId=${this.subsection._id}`,
            disabled: subsection.filter
          }
        })
      } else {
        console.log('navigationItems 4')
        const filteredSubsections = this.livingOption.subsections
        return filteredSubsections.map(subsection => {
          return {
            label: subsection.displayName,
            to: `/live/${this.livingOption._id}/subsection/${subsection._id}`,
            disabled: subsection.filter
          }
        })
      }
    },

    sidebarDescription () {
      if (this.$store.state.route.query.parentSubsectionId && this.subsection.subsections && this.subsection.subsections.length) {
        const parentSubsection = _.find(this.livingOption.subsections, subsection => {
          return subsection._id === this.$store.state.route.query.parentSubsectionId
        })
        return parentSubsection.description ? parentSubsection.description : this.livingOption.description
      } else {
        return this.subsection.description ? this.subsection.description : this.livingOption.description
      }
    },

    sidebarHeading () {
      if (this.$store.state.route.query.parentSubsectionId && this.subsection.subsections && this.subsection.subsections.length) {
        // get heading from subsection first, then parent if blank
        if (this.subsection.displayName[this.language.code]) {
          return `${this.livingOption.label[this.language.code]} - ${this.subsection.displayName[this.language.code]}`
        }

        const parentSubsection = _.find(this.livingOption.subsections, subsection => {
          return subsection._id === this.$store.state.route.query.parentSubsectionId
        })
        return `${this.livingOption.label[this.language.code]} - ${parentSubsection.displayName[this.language.code]}`
      } else if (this.subsectionChildType === 'subsection') {
        return `${this.livingOption.label[this.language.code]} - ${this.subsection.displayName[this.language.code]}`
      } else {
        return this.livingOption.label[this.language.code]
      }
    },

    subsectionChildType () {
      if (this.subsection.subsections && this.subsection.subsections.length) {
        return 'subsection'
      } else {
        return 'property'
      }
    }
  },

  watch: {
    $route () {
      if (!this.subsection.allPropertiesFloorplate || !this.subsection.allProperties.length) {
        this.showAllProperties = false
      }
    }
  },

  mounted () {
    this.showAllProperties = this.$route.query.showAllProperties
  },  

  methods: {
    generateRouterLink (id) {
      let routerLink = false
      this.subsection.subsections.forEach(subsection => {
        if (subsection.propertyIds.includes(id)) {
          routerLink = `/live/${this.livingOption._id}/subsection/${subsection._id}/property/${id}`
        }
      })
      return routerLink
    },

    toggleShowAllProperties () {
      this.showAllProperties = !this.showAllProperties
      this.$router.push({ query: { showAllProperties: this.showAllProperties }})
    },

    getRouterLink (child) {
      if (this.subsectionChildType === 'property') {
        return `/live/${this.livingOption._id}/subsection/${this.subsection._id}/property/${child._id}`
      } else {
        return `/live/${this.livingOption._id}/subsection/${child._id}`
      }
    }
  }
}
</script>
<style lang="scss">
.subsection {
  &__logo {
    position: absolute;
    top: 3rem;
    right: 4rem;
    z-index: 999;
    max-height: 10rem;
  }
}
</style>